import slotsDB from 'config/slotsApiMapping.json';

export default function getSlotInfo(codeString) {
  const targetSlot = slotsDB.find(({ id }) => (id === codeString?.toUpperCase()));
  if (targetSlot) return targetSlot;
};